/**
 * Created with IntelliJ IDEA.
 * User: Noam !
 * Date: 8/1/13
 * Time: 9:41 AM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var Marionette = require('marionette');
    var template = require('ui/textarea-field/templates/textareaField.tmpl');
    var TextareaFieldModel = require('ui/textarea-field/js/models/TextareaFieldModel');
    var Modernizr = require('modernizr');
    var Bubble = require("ui/bubble/Bubble");
    var EMPTY_VALUE = "";
    var Translator = require("i18n/translator");
    var _ = require("underscore");
    require('ui.plugins/jquery.inputCursor');


    // Parameters data, el
    // todo autofocus  move to html 5
    // todo placeholder  not tested / unsuported



    var TextareaField = Marionette.ItemView.extend({
        template:template,
        withUIComponents: true,
        errorMsg:null,
        // event handlers
        events:{
            "focus textarea":   "onTextareaFocus", // triggered when user is focus on the  textarea (in editable mode)
            "blur  textarea":    "onTextareaBlur", // triggered when user is blurred the  textarea (in editable mode)
            "input textarea":    "onTextareaChange", // triggered when user is blurred the  textarea (in editable mode)
            "cut   textarea":   "onTextareaChange",
            "paste textarea":   "onTextareaChange",
            "keyup textarea":   "onTextareaChange"
        },

        ui:{
            textarea: "textarea",
            textareaContainer: ".textarea-container",
            counter: ".textarea-chars-counter"
        },

        inputSize:null,

        initialize:function (options) {
            if (!options || !_.isPlainObject(options) ) {
                throw "TextareaField :: invalid argument: options is illegal.";
            }

            if (options.el) {
                options.placeholder = !_.isUndefined(this.$el.data('placeholder')) ? this.$el.data('placeholder') : options.placeholder;
            }

            options.value = !_.isUndefined(options.value) ? options.value : '';
            options.placeholder = !_.isUndefined(options.placeholder) ? options.placeholder : '';

            var textareaFieldModel = new TextareaFieldModel();
            textareaFieldModel.set(options);

            this.model = textareaFieldModel;
            this.permutation = options.permutation || TextareaField.PERMUTATION.B;
            this.theme = options.theme || TextareaField.THEME.DEFAULT;
            this.errorPosition = options.errorPosition || TextareaField.ERROR_POSITION.BOTTOM;
            this.autoFocus = options.autoFocus || false;

            this.listenTo(this.model, 'change:' + TextareaField.VALUE, this.showTextArea);

        },

        /**
         * Attaches the size class to the elements on the DOM (by the options inputSize attribute)
         * Also, decide what to show, the label (if there is no description) or the description text (if there is one)
         */
        onRender:function () {
            this.ui.textarea.addClass("textarea-perm-" + this.permutation);
            this.ui.textarea.addClass(this.theme);
            this.ui.textareaContainer.addClass("textarea-perm-" + this.permutation);
            this.showTextArea();
            this.setFocus(this.autoFocus);
            this._setCharCounterValue();
        },

        /**
         * Show the value in textarea editable mode
         *
         * NOTE: We are not handling the placeholder in NON HTML5 browsers.
         * This is because we don't have a reason to put a placeholder and just remove it when focus the textarea.
         */
        showTextArea:function () {
            var val = this.getValue();

            if (this.ui.textarea.val() !== val) {
                this.ui.textarea.val(val);
            }

            if (EMPTY_VALUE === this.getValue()) {
                this.showPlaceholder();
            }
            else {
                this.hidePlaceholder({silent:true});
            }
        },
        getValue:function () {
            return this.model.get(TextareaField.VALUE);
        },
        /**
         * Public method to change the value in the component.
         * As default, if the value is set from other view and not through the DOM, we are not triggers the event because we assume that whoever call this method already knows that the value has been changed.
         * @param value. String. The value to update the model with.
         */
        setValue:function (value, options) {
            options = options || {};
            options.silent = _.has(options, "silent") ? options.silent : true;

            this._setValue(value, options);
        },
        /**
         * Set the value in the internal model and triggers an event to whoever is listening to change on this view-component
         * @param value. String. The value to update the model with.
         * @param options Object. silent:true will not trigger the change event
         * @private
         */
        _setValue:function (value, options) {
            options = options || {};
            if (value !== this.model.get(TextareaField.VALUE)) {
                this.model.set(TextareaField.VALUE, value);

                if (!options.silent) {
                    this.trigger("change", value);
                }
            }
            this.model.resetCursor();
        },
        setValueAtCourser:function (value, options) {
            var currText = this.model.get(TextareaField.VALUE);
            var newText, addText;

            if(this.model.getCursorStart() === null || this.model.getCursorEnd() === null){
               newText = currText + " " + value;
            }
            else{
               newText = currText.slice(0, this.model.getCursorStart()) + value + currText.slice(this.model.getCursorEnd(), currText.length);
            }

            this.ui.textarea.val(newText);
            this.textareaIsChanged();
        },
        _saveCursorPosition: function(){
            var cursorStart, cursorEnd;

            cursorStart = this.ui.textarea[0].selectionStart;
            cursorEnd = this.ui.textarea[0].selectionEnd;

            this.model.setCursorPosition(cursorStart, cursorEnd);
        },
        setPlaceholder: function (val) {
            this.ui.textarea.attr('placeholder', val);
            this.model.set({"placeholder": val});
        },
        showPlaceholder: function () {
            if (!Modernizr.input.placeholder  && !this.ui.textarea.is(":focus")) {
                if (!this.placeholderIsSet) {
                    this.placeholderIsSet = true;
                    this.ui.textarea.addClass('placeholder');
                }
                this.ui.textarea.val(this.ui.textarea.attr('placeholder'));
            }
        },
        hidePlaceholder: function (options) {
            options = options || {};
            if (!Modernizr.input.placeholder ) {
                if (this.placeholderIsSet) {
                    this.ui.textarea.removeClass('placeholder');
                    this.placeholderIsSet = false;

                    if (!options.silent) {
                        this.ui.textarea.val(EMPTY_VALUE);
                    }
                }
            }
        },
        setError:function (isError, msg) {
            if (isError === true) {
                this.showTextArea();
                this.ui.textarea.addClass("error");
                this.errorMsg = msg;
            }
            else {
                this.ui.textarea.removeClass("error");
                this.errorMsg = null;
                if (this.uiComponents && this.uiComponents.TextareaFieldError) {
                    this.uiComponents.TextareaFieldError.close();
                }
            }
        },
        setEnabled: function (enabled) {
            this.model.set("enabled", enabled);
        },

        renderEnabled: function (model, enabled) {
            this.ui.textarea.prop("disabled", !enabled);
        },
        isEnabled: function () {
            return this.model.get("enabled");
        },
        setFocus: function(focus){
            if(focus){
                setTimeout(_.bind(function() {
                    this._focusInput();
                }, this), 1);
            }
        },

        _focusInput: function(){
            this.ui.textarea.focus();
            this.ui.textarea.inputcursor('focusEnd');
        },

        onTextareaFocus:function () {
            this._setErrorBubble();
        },
        _setErrorBubble: function () {
            if (this.ui.textarea.hasClass("error") && this.errorMsg && !this.uiComponents.TextareaFieldError) {
                this.uiComponents.host$.createAndRender("TextareaFieldError", {
                    type:Bubble,
                    options: this._getErrorBubbleOptions()
                });
            }
            this.hidePlaceholder();
        },
        _getErrorBubbleOptions: function() {
            var options = {
                targetControl:this.ui.textarea,
                position:this.errorPosition,
                icon:Bubble.ICON.ERROR,
                showCloseButton:false
            };

            if (_.isString(this.errorMsg)) {
                options.text = this.errorMsg;
            }
            else {
                options.contentView = this.errorMsg;
            }

            return options;
        },

       /**
         * Triggered on any change in the input value.
         * If the new value is not valid, we set the textarea value to be the 'lastKnownGoodValue' from the model
         *
         * NOTE: setTimeout is used to solve an issue with Firefox.
         * Firefox doesn't catch an input/change event when user uses right click and paste/cancel (when not using setTimeout 0)
         */
        onTextareaChange:function () {
            var that = this;
            setTimeout(function () {
                that.textareaIsChanged();
            }, 0);
        },

        onTextareaBlur: function() {
            this.setError(false);
            this.textareaIsChanged();
            this._saveCursorPosition();
            this.trigger("blur");
        },

        textareaIsChanged:function () {
            var newVal = this.ui.textarea.val();
            if (newVal !== this.getValue()) {
                var validationErr = this.model.validate(newVal.trim());
                if (validationErr === false || validationErr.length === 0) {    //BB validations sucks returns either false or "" ,when no error
                    this._setValue(newVal);
                    this.setError(false);
                }
                else {
                    this.setError(true, Translator.translate(validationErr));
                    this._setErrorBubble();
                    this.ui.textarea.val(this.getValue());
                }
            this._setCharCounterValue();
            }
        },

        _setCharCounterValue: function(){
            var maxLength = this.model.get("maxChars");
            var currLength = this.getValue().length;
            var charsLeft = maxLength - currLength;
            charsLeft = charsLeft > 0 ? charsLeft : 0; //text area will allow addition of whitespace chars which will be trimmed on save
            this.ui.counter.text(charsLeft);
        }
    });

    /**
     * Public static eNum of the optional permutation
     */
    TextareaField.PERMUTATION = {
        A:1,
        B:2,
        C:3,
        D:4,
        E:5,
        F:6,
        G:7
    };
    TextareaField.THEME = {
        DEFAULT: "default-theme",
        NIGHT: "night-theme"
    };
    TextareaField.ERROR_POSITION = Bubble.POSITION;
    // Public static variable that being used by the widget and this view to get and set the value in the relevant model attribute
    TextareaField.VALUE = "value";

    return TextareaField;
});
